export const API_BASE_URL =
	import.meta.env.VITE_API_URL || "http://localhost:8000/api/v1";
export const RTVI_BASE_URL = import.meta.env.VITE_RTVI_BASE_URL || "";
export const CANDIDATE_APP_URL =
	import.meta.env.VITE_CANDIDATE_URL ||
	(typeof window !== "undefined" ? window.location.origin : "");
// Base URL of the Common volunteer app (fixed across environments). Invite
// links are `${COMMON_APP_URL}/invite/<campaign_slug>`.
export const COMMON_APP_URL = "https://common.americamajority.org";
export const STRIPE_PUBLISHABLE_KEY =
	import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || "";
